import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Menu, Content, MenuItem } from '@root/components/Dropdown';

interface IProps {
  onSelect: (v: string) => void;
  language: string;
}

const LANGUAGE_LIST = [
  { value: 'it-IT', name: 'Italiano' },
  { value: 'de-DE', name: 'Deutsch' },
  { value: 'en-US', name: 'English (US)' },
  { value: 'es-ES', name: 'Español' },
  { value: 'in-ID', name: 'Bahasa Indonesia' },
  { value: 'fr-FR', name: 'Français' },
  { value: 'en-GB', name: 'English (UK)' },
  { value: 'ja-JP', name: '日本語(JP)' },
  { value: 'th-TH', name: 'ไทย' },
  // { value: 'zh-CN', name: '中文' },
];

const LanguageSelector = ({ onSelect, language }: IProps) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [isChange, setIsChange] = useState(false);

  const onSelectLang = useCallback(
    (v: string) => {
      setVisible(false);
      onSelect(v);
      setIsChange(true);
    },
    [onSelect],
  );

  const handleOpen = useCallback((value: boolean) => {
    setVisible(value);
  }, []);

  const languageName = useMemo(() => {
    if (!isChange) {
      return t('other_language');
    }
    return (
      LANGUAGE_LIST.find((item) => item.value === language)?.name ||
      t('other_language')
    );
  }, [isChange, language, t]);

  return (
    <Dropdown
      visible={visible}
      align="center"
      onOpen={handleOpen}
      className="language-dropdown"
    >
      <Menu>
        <div className="lang-name cursor-pointer">{languageName}</div>
      </Menu>
      <Content>
        {LANGUAGE_LIST.map((lang) => (
          <MenuItem key={lang.value} onClick={() => onSelectLang(lang.value)}>
            <div className="cursor-pointer">
              <p>{lang.name}</p>
            </div>
          </MenuItem>
        ))}
      </Content>
    </Dropdown>
  );
};
export default LanguageSelector;
